/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { defineMessages, FormattedMessage } from 'react-intl'
import { ErrorIds } from './containers/ShopErrorScreen/constants'


export const ProductIds = {
    package_s: 'package_s',
    package_m: 'package_m',
    package_l: 'package_l',
    package_xl: 'package_xl',
}

export const PRODUCT_ORDER = [
    ProductIds.package_xl,
    ProductIds.package_l,
    ProductIds.package_m,
    ProductIds.package_s,
]

export const Products = {
    [ProductIds.package_s]: {
        title: (
            <FormattedMessage
                id='shop.product.title.package_s'
                defaultMessage='Малый запас промресурса'
            />
        ),
        description: (
            <FormattedMessage
                id='shop.product.description.package_s'
                defaultMessage='Пополнение запаса промресурса позволит вашему клану быстрее развиться, модернизируя строения Укрепрайона и подготавливая различные клановые резервы.'
            />
        ),
        images: {
            big: require('./images/big/package_s.png'),
            small: require('./images/small/package_s.png'),
        },
    },
    [ProductIds.package_m]: {
        title: (
            <FormattedMessage
                id='shop.product.title.package_m'
                defaultMessage='Средний запас промресурса'
            />
        ),
        description: (
            <FormattedMessage
                id='shop.product.description.package_m'
                defaultMessage='Пополнение запаса промресурса позволит вашему клану быстрее развиться, модернизируя строения Укрепрайона и подготавливая различные клановые резервы.'
            />
        ),
        images: {
            big: require('./images/big/package_m.png'),
            small: require('./images/small/package_m.png'),
        },
    },
    [ProductIds.package_l]: {
        title: (
            <FormattedMessage
                id='shop.product.title.package_l'
                defaultMessage='Грузовик промресурса'
            />
        ),
        description: (
            <FormattedMessage
                id='shop.product.description.package_l'
                defaultMessage='Пополнение запаса промресурса позволит вашему клану быстрее развиться, модернизируя строения Укрепрайона и подготавливая различные клановые резервы.'
            />
        ),
        images: {
            big: require('./images/big/package_l.png'),
            small: require('./images/small/package_l.png'),
        },
    },
    [ProductIds.package_xl]: {
        title: (
            <FormattedMessage
                id='shop.product.title.package_xl'
                defaultMessage='Вагон промресурса'
            />
        ),
        description: (
            <FormattedMessage
                id='shop.product.description.package_xl'
                defaultMessage='Пополнение запаса промресурса позволит вашему клану быстрее развиться, модернизируя строения Укрепрайона и подготавливая различные клановые резервы.'
            />
        ),
        images: {
            big: require('./images/big/package_xl.png'),
            small: require('./images/small/package_xl.png'),
        },
    },
}

export const SHOP_TITLE = (
    <FormattedMessage
        id='shop.title'
        defaultMessage='Промресурс для клана'
    />
)

export const SHOP_PRODUCT_PURCHASED = (
    <FormattedMessage
        id='shop.product.status.purchased'
        defaultMessage='Промресурс куплен'
    />
)

export const CANNOT_PURCHASE_STATUS = (
    <FormattedMessage
        id='shop.status.cannot.purchase'
        defaultMessage='Невозможно купить промресурс: вы вступили в клан уже после начала акции.'
    />
)

export const ACTION_AVAILABLE_BEFORE = (endDatetime) => (
    <FormattedMessage
        id='shop.status.time.available'
        defaultMessage='Акция доступна до: {endDatetime}'
        values={{
            endDatetime: endDatetime.format('LL'),
        }}
    />
)

export const ACTION_TIME_LEFT = (timer) => (
    <FormattedMessage
        id='shop.status.time.left'
        defaultMessage='До завершения акции осталось: {timer}'
        values={{
            timer,
        }}
    />
)

export const errors = defineMessages({
    [ErrorIds.NOT_CLAN_MEMBER]: {
        id: 'shop.error_notification.not_clan_member',
        defaultMessage: 'Действие недоступно: вы не состоите в клане.',
    },
    [ErrorIds.EXPIRED]: {
        id: 'shop.error_notification.action_expired',
        defaultMessage: 'Акция продажи кланам промресурса закончилась.',
    },
    [ErrorIds.INTERNAL_ERROR]: {
        id: 'shop.error_notification.internal_error',
        defaultMessage: 'Не удалось совершить действие: попробуйте повторить попытку позже.',
    },
})



// WEBPACK FOOTER //
// ./containers/ShopView/constants.jsx